import { createAction, props } from '@ngrx/store';
import { CatalogResponse } from '../../models/catalog.model';

export const loadCatalog = createAction('[Catalog] Load Catalog');
export const loadCatalogSuccess = createAction('[Catalog] Load Catalog Success', props<{ catalog: CatalogResponse; customerId: string; customerName: string }>());
export const loadCatalogFailure = createAction('[Catalog] Load Catalog Failure', props<{ error: string }>());
export const invalidateCatalog = createAction('[Catalog] Invalidate Catalog');
